import { createSelector } from "reselect";
import { selectors as storageSelectors } from "../storage";
import { parseQueryString, getLegacyRedirect } from "./utils";

export const getCurrentRoute = state => state.router.location;

export const routeContains = (state, path) => {
  const currentRoute = getCurrentRoute(state);
  if (currentRoute && currentRoute.hash) {
    return currentRoute.hash.indexOf(path) >= 0;
  }
  return false;
};

// Say if you wanna get https://bookshelf.vitalsource.com/ out of https://bookshelf.vitalsource.com/#/blah
export const getRootRoute = state => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

export const getRedirectRoute = state => {
  const storedRedirect =
    getLegacyRedirect() ||
    storageSelectors.getKey(state, "storedRedirect", {
      userScope: false
    });
  if (!storedRedirect) {
    return false;
  }
  storedRedirect.href = `${getRootRoute(state)}${storedRedirect.pathname}${
    storedRedirect.hash
  }`;
  storedRedirect.relative = `${storedRedirect.hash.slice(1)}${
    storedRedirect.search.length > 1 ? storedRedirect.search : ""
  }`;
  return storedRedirect;
};

export const getSearch = state => state.router.location.search;

export const getQueryParams = createSelector(getSearch, search =>
  parseQueryString(search)
);

export const getQueryParam = (state, key) => getQueryParams(state)[key];

export const getRouteUpdateTime = state => state.router.updateTime;

export const isNative = state => getQueryParam(state, "native") === "true";

export const getSubscriptionFromRoute = state => {
  const currentRoute =
    getCurrentRoute(state).hash && getCurrentRoute(state).hash.split("?")[0];
  if (currentRoute) {
    let vbid = currentRoute.match(/explore\/([^/]+)/);
    if (vbid && vbid.length) {
      return vbid[1];
    }
  }
  return null;
};

/*
 * This function will return the path details
 * ex: will return "/sub123" from "explore/sub123"
 */
export const getPathDetails = (state, path) => {
  const pathDetails =
    getCurrentRoute(state).hash && getCurrentRoute(state).hash.split(path)[1];
  if (pathDetails) {
    return pathDetails;
  }
  return "";
};
